'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useInstantSearch, useStats } from 'react-instantsearch';

// useStats (unlike useInstantSearch) suspends SSR until results arrive, so server and client render the same count (CON-8902).
const CategoryAlgoliaResultsCount = () => {
  const $ = _c(2);
  const {
    nbHits
  } = useStats();
  const {
    status
  } = useInstantSearch();
  const hasProductsLoaded = status === "idle" || status === "error";
  if (!hasProductsLoaded || !(nbHits > 0)) {
    return null;
  }
  const t0 = `${nbHits} Products`;
  let t1;
  if ($[0] !== t0) {
    t1 = <span className="text-sm text-gray-light2 font-normal">{t0}</span>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default CategoryAlgoliaResultsCount;